var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrcodeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1761 0H0V12.1761H12.1761V0ZM9.74092 9.74092H2.43523V2.43523H9.74092V9.74092Z",
    fill: "#03AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30632 4.87158H4.87109V7.30681H7.30632V4.87158Z",
    fill: "#03AB70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3548 0H19.4844V2.43523H24.3548V0Z",
    fill: "#03AB70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4798 9H21.9151V7.30625H24.3503V4.87102H17.0446V2.43579H14.6094V4.87102V6.08863V7.30625H19.4798V9Z",
    fill: "#03AB70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0446 9.74146H14.6094V12.1767H17.0446V9.74146Z",
    fill: "#03AB70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.6116H14.6094V17.0468H17V14.6116Z",
    fill: "#03AB70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43523 21.917H4.87046V19.4818H2.43523V14.6113H0V24.3522H2.43523V21.917Z",
    fill: "#03AB70"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30632 14.6113H4.87109V17.0466H7.30632V14.6113Z",
    fill: "#03AB70"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6104 24.3522H17.0456V19.4818H12.1751V14.6113H9.73992V19.4818H7.30469V24.3522H9.73992V21.917H10.9575H12.1751H14.6104V24.3522Z",
    fill: "#03AB70"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 19.1201L26.4698 22.3004L23.2896 19.1201L23.8745 18.5352L26.0562 20.7169V13.3608H26.8834V20.7169L29.0651 18.5352L29.65 19.1201ZM31.7638 23.1217H21.1758V23.9488H31.7638V23.1217Z",
    fill: "#03AB70"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2173 19.1201L26.6157 22.7216H32.1653V24.3488H20.7773V22.7216H26.327L22.7254 19.1201L23.876 17.9695L25.6578 19.7512V12.9608H27.2849V19.7512L29.0666 17.9695L30.2173 19.1201Z",
    fill: "#03AB70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeGreen);
export default __webpack_public_path__ + "static/media/qrcode-green.89b056f1.svg";
export { ForwardRef as ReactComponent };